<template>
  <div id="sdGroup">
    <header class="has-shadow">
      <div class="nav-wrapper">
        <div class="logo-text">
          <span class="logo-img">{{title}}</span>
        </div>
        <div class="more-icon">
          <img
            src="../../assets/img/videoDetail/search@2x.png"
            alt=""
            class="icon-img"
            @click="goRouter('SdSearch')"
          >
        </div>
      </div>
      <div class="search-bar">
        <img
          src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
          alt=""
          class="back-icon"
          @click="goRouter('SdSeeDoctor')"
        >
      </div>
    </header>
    <div class="depart-scroll" ref="departScroll">
      <office :departmentId="departmentId" @childsend="parentget"></office>
    </div>
  </div>
</template>
<script>
  import OfficeKinds from "../public/OfficeKinds";
  import { Wechat } from "@/common/Wechat";

  export default {
    components: {
      office: OfficeKinds
    },
    data() {
      return {
        title: "",
        departmentId: ""
      };
    },
    created() {
      this.departmentId = this.$route.query.departmentId;
      this.weChatShare();
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
      // console.log(this.title)
      // 子组件传过来的值在此生命周期显示
    },
    watch: {
      departmentId(n, o) {
        if (!o) {
          return;
        }
        this.weChatShare();
      },
      // 深度观察监听
      $route: {
        handler: function(val, oldVal) {
          if (val.path && val.path == "/SdSeeGroup") {
            this.weChatShare();
          }
        },
        // immediate: true,
        deep: true
      },
    },
    methods: {
      goRouter(val) {
        this.$router.push(val);
      },
      weChatShare() {
        const wechat = Wechat.getInstance();
        const data = {
          title: "深读健康", // 分享标题
          desc: "先看视频再问诊，明白一点！深读为你的健康提供专业服务", // 分享描述
          link: decodeURIComponent(location.href), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://wx.shendutv.com/images/638667815392809725.png" // 分享图标
        };
        wechat.doSomethingAfterWxConfig(this.$http, wechat.weChatShare(data));
      },
      parentget(v) {
        this.title = v;
      }
    }
  };
</script>
<style lang="postcss" scoped>
  #sdGroup {
    & .has-shadow {
      -webkit-box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
    }
    & header {
      position: relative;
      width: 100%;
      height: 88px;
      /* padding: 48px 30px 20px 30px; */
      padding: 27px 30px;
      background-color: #fffffd;
      position: fixed;
      top: 0;
      z-index: 999;
      box-sizing: border-box;
      overflow: hidden;

      & .nav-wrapper {
        display: flex;
        box-sizing: border-box;
      }
      & .logo-text {
        width: 100%;
        position: relative;
        z-index: 9999;
        & .logo-img {
          min-width: 160px;
          height: 43px;
          line-height: 43px;
          font-size: 34px;
          position: absolute;
          top: -5px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
        }
      }
      & .nav-box {
        display: none;
      }
      & .title-nav {
        padding: 30px;
        padding-left: 0;
        margin: -30px;
        display: -webkit-box;
        overflow-x: scroll;
        font-size: 32px;
        font-family: Source Han Sans CN;
        box-sizing: border-box;
        margin-right: 30px;
        color: #d0d0d0;
        margin-left: 80px;
        & li:first-child {
          margin-left: 0;
        }
        & .nav-text {
          margin: 0 20px;
          height: 50px;
          line-height: 60px;
        }
        & li:first-child {
          margin-left: 0;
        }
        & .activenav {
          position: relative;
          font-size: 32px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          color: #37bd19;
        }
      }
      & .title-nav::-webkit-scrollbar {
        display: none;
      }
      & .more-icon {
        position: absolute;
        /* right: 53px; */
        right: 30px;
        & .icon-img {
          width: 30px;
          height: 30px;
        }
      }
      & .search-bar {
        width: 100%;
        margin-top: 31px;
        position: relative;
        display: flex;
        background-color: #38383d;
        border-radius: 39px !important;
        border: none;
        & .search-icon {
          position: absolute;
          width: 31px;
          top: 50%;
          margin-top: -19px;
          /* left: 30px; */
        }
        & .back-icon {
          position: absolute;
          width: 16px;
          top: -31px;
          /* left: 30px; */
        }
      }
    }
    & .depart-scroll {
      padding-top: 90px;
      padding-bottom: 80px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shenduSeeDoctor/SdSeeGroup.vue